import styled from "styled-components";

import { Button } from "@similarweb/ui-components";

export const ButtonWithIconWrapper = styled.div`
    position: relative;
    width: max-content;
`;

export const GAButton = styled(Button)`
    padding-left: 25px;
`;
